import { updateItemInCollection } from "directus/src/operations";

export async function updateOpeningInterview({ interviewId, item }) {
    try {
        const query = {
            fields: [
                "id",
                "applicant",
                "date_scheduled",
                "title",
                "recording_url",
                "status",
                "client_feedback",
                "internal_feedback",
                "transcript",
                "is_cleared",
            ],
        };

        const data = await updateItemInCollection(
            "opening_interviews",
            interviewId,
            item,
            query
        );

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
